import React, { useEffect, useRef, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { InstantSystemQuery, InstantSystemWidgetBlockFieldsFragment } from "../../../../graphql-types"
import * as globalBlockStyles from "../main-blocks/main-blocks.module.scss"
import * as blockStyles from "./instant-system-widget-block.module.scss"
import "./custom-itinerary.scss"
import "./itinerary-widget.scss"
import { ReactSVG } from "react-svg"
import { infoTrafficBlockPicto } from "../../../../static/images"
import { useIsMobile } from "../../../hooks"

type RenderProps = {
  block: InstantSystemWidgetBlockFieldsFragment
}

const InstantSystemWidgetBlock: React.FC<RenderProps> = ({ block }) => {
  const data: InstantSystemQuery = useStaticQuery(graphql`
    query InstantSystem {
      datoCmsInstantSystemConfig {
        ...InstantSystemConfiguration
      }
    }
  `)
  const component = useRef<HTMLElement>()
  const widgetIs = useRef<HTMLDivElement>()
  const isItineraryV1 =
    block.widgetType === "Itinéraire" && data.datoCmsInstantSystemConfig?.itineraryWidget.startsWith("//")

  const isMobile = useIsMobile()

  const [isMapVisible, setIsMapVisible] = useState(isMobile || false)

  const toggleMapVisibility = () => {
    const nextVisibility = !isMapVisible
    setIsMapVisible(nextVisibility)
    // This is a workaround to force the map to resize when it is shown to allow the map to be displayed correctly
    if (nextVisibility) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"))
      }, 100)
    }
  }

  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }
    const scriptId = "installer-script"
    if (document.getElementById(scriptId) && block.widgetType === "Itinéraire" && isItineraryV1) {
      // initializeWidget is a function provided by the Instant System Widget script
      // it is automatically called the first time but we need to call it again when the widget is re-rendered
      //@ts-ignore
      window.initializeWidget(widgetIs.current) // mount widget
      return
    }
    const script = document.createElement("script")
    script.id = scriptId

    document.getElementsByTagName("body")[0].appendChild(script)
    script.async = true
    script.type = "text/javascript"

    switch (block.widgetType) {
      case "Info trafic":
        script.src = data.datoCmsInstantSystemConfig?.infoTrafficWidget
        break
      case "Itinéraire":
        script.src = data.datoCmsInstantSystemConfig?.itineraryWidget
        break
      case "Horaires":
        script.src = ""
        break
    }
  }, [])
  return (
    <section
      className={`${blockStyles.block} ${globalBlockStyles.mainBlocksCard} ${block.widgetType === "Itinéraire" ? blockStyles.blockIti : ""}`}
      ref={component}
    >
      <div className={blockStyles.blockHeader}>
        <ReactSVG
          src={infoTrafficBlockPicto}
          className={blockStyles.blockPicto}
          beforeInjection={svg => svg.setAttribute("aria-hidden", "true")}
        />
        <h2 className={blockStyles.title}>{block.widgetType}</h2>
      </div>

      {block.widgetType === "Info trafic" && <div id="is-WidgetWrapper_Traffic"></div>}
      {block.widgetType === "Itinéraire" &&
        // <div data-is-widget data-domain="services.fluo.grandest.fr" data-widget-type="trip-planner"></div>
        (isItineraryV1 ? (
          <div
            ref={widgetIs}
            data-is-widget
            data-domain={data.datoCmsInstantSystemConfig?.itineraryWidget
              ?.replace("//", "")
              .replace("/widget/v1/installer.js", "")}
            data-widget-type="trip-planner"
          ></div>
        ) : (
          <>
            <div id="is-WidgetWrapper"></div>
            <div id="is-MapWrapper" style={{ display: isMapVisible ? "block" : "none" }}></div>
            <button
              type="button"
              onClick={toggleMapVisibility}
              className={blockStyles.mapButton}
              aria-label={data.datoCmsInstantSystemConfig?.toggleMapAriaLabel}
              aria-expanded={isMapVisible}
            >
              {isMapVisible ? "-" : "+"}
            </button>
          </>
        ))}
      {block.widgetType === "Horaires" && <div id="is-WidgetWrapper_Schedule"></div>}
    </section>
  )
}
export const fragments = graphql`
  fragment InstantSystemWidgetBlockFields on DatoCmsInstantSystemWidgetBlock {
    __typename
    id
    widgetType
  }
  fragment InstantSystemConfiguration on DatoCmsInstantSystemConfig {
    infoTrafficWidget
    itineraryWidget
    toggleMapAriaLabel
  }
`
export default InstantSystemWidgetBlock
